import { useCallback } from 'react';
import { useApiPost } from '../../api/Api.hooks';
import { StudyParticipant } from '../../models/StudyParticipant';

export function useQualifyStudyParticipant(id: number) {
  const { data, isLoading, error, post } = useApiPost<StudyParticipant>(
    `study-participants/${id}/qualify`
  );
  const qualifyStudyParticipant = useCallback(
    (isQualified: boolean) => {
      post({ isQualified });
    },
    [post]
  );
  return {
    qualifiedStudyParticipant: data,
    qualifyingStudyParticipant: isLoading,
    qualifiedStudyParticipantError: error,
    qualifyStudyParticipant
  };
}
